import React from 'react';
import { profile } from '../../data/profile';

/**
 * Footer - Site footer with copyright and version
 */
const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer
      className="text-center py-8 border-t"
      style={{ borderColor: 'var(--color-border)' }}
    >
      <p className="text-sm" style={{ color: 'var(--color-text-muted)' }}>
        © {currentYear} {profile.name}. Built with React & a lot of ☕
      </p>
      <p className="text-xs mt-2" style={{ color: 'var(--color-text-muted)' }}>
        <span className="font-mono">v1.0.0</span> • Last deployed: {new Date().toLocaleDateString()}
      </p>
    </footer>
  );
};

export default Footer;
